// src/pages/produtos/produtos/VariacaoTab.js
import { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import VariacaoCad from '../variacao/VariacaoCad';
import VariacaoSearch from '../variacao/VariacaoSearch';
import { useVariacao } from '../../../contexts/produtos/VariacaoContext';
import { useProdutoVariacao } from '../../../contexts/produtos/ProdutoVariacaoContext';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import { IoMdAddCircle } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';
export default function VariacaoTab({ produto, setProduto, disableCampos }) {
  const { variacoes } = useVariacao();
  const { produtoVariacoes, carregar, adicionar, remover } = useProdutoVariacao();
  const { showMessage } = useMessage();
  const { showYesNo } = useYesNo();
  const [selecionada, setSelecionada] = useState(null);
  const [codigo, setCodigo] = useState('');
  const [busca, setBusca] = useState(false);
  const [cadastro, setCadastro] = useState(false);
  const [ocupado, setOcupado] = useState(false);
  useEffect(() => {
    setSelecionada(null); setCodigo('');
    carregar(produto.id).catch(erro => showMessage(erro.message, 'danger'));
    // A lista é recarregada quando o produto do cadastro muda.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produto.id]);
  const escolher = item => { setSelecionada(item); setCodigo(item?.id || ''); setBusca(false); };
  const executar = async operacao => {
    setOcupado(true);
    try { const lista = await operacao(); setProduto(atual => ({ ...atual, produtoVariacoes:lista })); escolher(null); }
    catch (erro) { showMessage(erro.message || 'Não foi possível alterar as variações do produto.', 'danger'); }
    finally { setOcupado(false); }
  };
  const incluir = e => {
    e.preventDefault();
    if (!selecionada) return showMessage('Selecione uma variação.', 'warning');
    executar(() => adicionar({ produtoId:produto.id, variacaoId:selecionada.id }));
  };
  const bloqueado = disableCampos || ocupado || !produto.id;
  return <div>
    {!produto.id && <p>Salve o produto para vincular variações.</p>}
    <div className="input-group" style={{ marginBottom:10, alignItems:'end' }}>
      <Input label="Variação" value={codigo} disabled={bloqueado} btnBuscarDisabled={bloqueado} btnAddDisabled={bloqueado} onChange={e => { setCodigo(e.target.value); setSelecionada(null); }}
        onBlur={() => escolher(variacoes.find(v => Number(v.id) === Number(codigo)) || null)} btnBuscar={() => setBusca(true)} btnAdd={() => setCadastro(true)} />
      <Input value={selecionada?.descricao || ''} size={300} disabled />
      <button type="button" className="btn btn-secondary" disabled={bloqueado} onClick={incluir}><IoMdAddCircle /> Adicionar</button>
    </div>
    <div className="table-responsive"><table className="table table-bordered"><thead><tr>
      <th>Código</th><th>Descrição</th><th>Qtd. Itens</th><th>Ações</th>
    </tr></thead><tbody>{produtoVariacoes.map(item => <tr key={item.id}>
      <td style={{textAlign:'right'}}>{item.variacaoId}</td><td>{item.variacao?.descricao}</td>
      <td style={{textAlign:'right'}}>{item.variacao?.variacaoItens?.length || 0}</td>
      <td className="text-center"><button type="button" className="btn btn-danger btn-sm" disabled={bloqueado}
        onClick={async () => { if (await showYesNo('Deseja remover a variação do produto?')) executar(() => remover(item)); }}><MdDelete /></button></td>
    </tr>)}{!produtoVariacoes.length && <tr><td colSpan="4" className="text-center">Nenhuma variação vinculada</td></tr>}</tbody></table></div>
    <VariacaoSearch show={busca} onHide={() => setBusca(false)} onSelectVariacao={escolher} />
    <VariacaoCad show={cadastro} onHide={() => setCadastro(false)} />
  </div>;
}
